import { Component, Input, OnChanges } from '@angular/core';
import { Event } from '../modules/event';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrl: './list.component.scss'
})
export class ListComponent implements OnChanges {

  @Input() events: Event[] = [];

  public expand: boolean = true;

  ngOnChanges() {
    if (this.expand) {
      let content = (document.getElementById('events-accordion-content') as HTMLDivElement);
      content.style.setProperty('max-height', 'none');
    }
  }

  updateAccordion() {
    this.expand = !this.expand;
    let content = (document.getElementById('events-accordion-content') as HTMLDivElement);
    if (this.expand) {
      content.style.setProperty('max-height', 'none');
    } else {
      content.style.setProperty('max-height', '0px');
    }
  }

}
